var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserRoles(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 23.1666H21V19.4166C20.9976 17.3465 19.3201 15.669 17.25 15.6666V14.1666C20.1482 14.1698 22.4968 16.5185 22.5 19.4166V23.1666Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 23.1666H15V19.4166C14.9976 17.3466 13.3201 15.6691 11.25 15.6666H6.75C4.67994 15.6691 3.00244 17.3466 3 19.4166V23.1666H1.5V19.4166C1.50339 16.5185 3.85191 14.17 6.75 14.1666H11.25C14.1481 14.17 16.4966 16.5185 16.5 19.4166V23.1666Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 2.16663V3.66663C17.0711 3.66663 18.75 5.34556 18.75 7.41663C18.75 9.48769 17.0711 11.1666 15 11.1666V12.6666C17.8995 12.6666 20.25 10.3161 20.25 7.41663C20.25 4.51713 17.8995 2.16663 15 2.16663L15 2.16663Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.75 7.41663C3.75 4.51713 6.10051 2.16663 9 2.16663C10.3924 2.16663 11.7277 2.71975 12.7123 3.70432C13.6969 4.68888 14.25 6.02424 14.25 7.41663C14.25 10.3161 11.8995 12.6666 9 12.6666C6.10051 12.6666 3.75 10.3161 3.75 7.41663ZM12.75 7.41663C12.75 5.34556 11.0711 3.66663 9 3.66663C6.92893 3.66663 5.25 5.34556 5.25 7.41663C5.25 9.48769 6.92893 11.1666 9 11.1666C11.0711 11.1666 12.75 9.48769 12.75 7.41663Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserRoles);
export default __webpack_public_path__ + "static/media/user-roles.6e26382a6e65f2d227a4ab7ef9b5fc5c.svg";
export { ForwardRef as ReactComponent };